import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'

Vue.use(VueI18n)

const DEFAULT_LANG = (process.env.VUE_APP_DEFAULT_LANG || 'zh').toLowerCase()

// Detect default language
function detectLanguage() {
  const savedLang = localStorage.getItem('language')
  if (savedLang) {
    return savedLang
  }

  if (['en', 'zh'].includes(DEFAULT_LANG)) {
    return DEFAULT_LANG
  }

  // Browser language detection
  const browserLang = navigator.language || navigator.userLanguage
  if (browserLang.toLowerCase().startsWith('en')) {
    return 'en'
  }
  
  return 'zh'
}

const i18n = new VueI18n({
  locale: detectLanguage(),
  fallbackLocale: ['en', 'zh'].includes(DEFAULT_LANG) ? DEFAULT_LANG : 'zh',
  messages: {
    zh,
    en
  }
})

export default i18n
